import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';

import { useAppState } from '@/features/authorization/provider/useAppState';
import { AutogeneratedChatMessage } from '@/features/chats/components/AutogeneratedChatMessage';
import { ReceivedChatMessage } from '@/features/chats/components/ReceivedChatMessage';
import { SentChatMessage } from '@/features/chats/components/SentChatMessage';

type Props = { message: ClientChatMessage };

export const ChatMessage: FC<Props> = ({ message }) => {
  const { userId } = useAppState();

  if (message.autoGenerated) {
    return <AutogeneratedChatMessage message={message} />;
  } else {
    if (message.senderId === userId) {
      return (
        <SentChatMessage
          message={message}
          pending={message.sentTime === undefined}
        />
      );
    } else {
      return <ReceivedChatMessage message={message} />;
    }
  }
};
